var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTpego(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_720_2514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2823 8.28289V16.1299C22.8578 14.7419 19.4883 13.3814 16.1051 12.0208C13.6846 12.9966 11.2641 13.9723 8.81611 14.9755V23.0422C8.71984 22.9874 8.66483 22.9874 8.63733 22.9461C7.02824 20.981 5.80422 18.8922 5.88675 16.2123C5.95552 13.7799 5.9005 11.3475 5.9005 8.9288C5.9005 8.7364 5.9005 8.544 5.9005 8.29664C9.29746 6.9224 12.6944 5.54814 16.1051 4.16016C19.4883 5.5344 22.8715 6.89491 26.2823 8.28289ZM16.1051 8.87382C18.5256 9.84953 20.9186 10.8115 23.353 11.801V10.2343C20.9186 9.24486 18.4981 8.26915 16.1051 7.30718C13.6434 8.29664 11.2366 9.27235 8.87112 10.2343V11.801C11.3191 10.8115 13.6984 9.84953 16.1051 8.87382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2656 24.7229V15.935C12.192 15.1572 14.1045 14.393 16.0583 13.6016C19.4158 14.9525 22.7868 16.3034 26.2817 17.709C25.9652 18.6232 25.6487 19.4965 25.3323 20.4381C22.1676 19.169 19.1131 17.941 16.0583 16.7264C15.0952 17.1085 14.1458 17.4906 13.1826 17.8863V23.5083C14.0908 24.2315 15.0539 25.0094 16.0721 25.8418C17.2692 24.8456 18.4251 23.8904 19.6771 22.8533C18.9067 22.5395 18.2737 22.2802 17.5582 22.0074C17.5307 22.2802 17.5169 22.5122 17.4894 22.8125C17.0628 23.1672 16.5812 23.5493 16.0583 23.9859C15.563 23.5902 15.0952 23.2082 14.6274 22.8397V18.8688C15.0815 18.6914 15.5493 18.4867 16.0446 18.2821C18.8241 19.401 21.6172 20.52 24.4793 21.6662C22.1814 24.8184 19.2507 27.1655 16.0583 29.2805C13.9669 27.9432 12.0406 26.4423 10.2656 24.7229Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_720_2514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpego);
export default __webpack_public_path__ + "static/media/tpego.ed2d1771bdb3f8123cd722974f671195.svg";
export { ForwardRef as ReactComponent };